import { Alert, AlertProps, Button, Snackbar, Typography } from '@mui/material';
import { FC } from 'react';
import { ITheme } from '../../../utils/theme';

export interface IPluginResponseAlertProps extends AlertProps {
  description?: string,
  onClose: () => void,
  open: boolean,
}

export const PluginResponseAlert: FC<IPluginResponseAlertProps> = ({
  severity = 'error',
  description = '',
  onClose,
  open
}) => {
  const [title = '', text = ''] = description.split('!');
  const parts = text.split('.');
  parts.pop();
  return (
    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open}>
      <Alert
        severity={severity}
        title={title}
        variant="filled"
      >
        <Typography sx={{ fontWeight: 'bold', mb: 1 }}>{title}!</Typography>
        {parts.map(t => (<Typography key={t} sx={{ mb: 1 }} dangerouslySetInnerHTML={{ __html: `${t}.` }} />))}
        <Button
          variant='text'
          sx={{ color: (theme: ITheme) => theme.palette.warning.light, fontWeight: 'bold', float: 'right' }}
          onClick={onClose}
        >
          OK
        </Button>
      </Alert>
    </Snackbar>
  )
}